export default __webpack_public_path__ + "static/media/Champagne pink Christmas wreath primary.493ccab3.jpg";